const MARKUP_CLASSNAMES = {
  socialMedia: 'col--sm12 col--md2',
};

export default MARKUP_CLASSNAMES;
